(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spoto-back-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const backButton = target?.closest('[data-spoto-back-button]');

    if (!backButton) return;

    let sameStoreReferrer = false;
    if (document.referrer) {
      try {
        sameStoreReferrer = new URL(document.referrer).origin === window.location.origin;
      } catch (_error) {
        sameStoreReferrer = false;
      }
    }

    if (sameStoreReferrer && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
